<div class="featured-area ptb-100">
    <div class="container">
        <div class="featured-inner-box">
            <div class="featured-slides" *ngIf="data">
                <owl-carousel-o [options]="featuredSlides">
                    <ng-template carouselSlide *ngFor="let content of data">
                        <div class="featured-single-card">
                            <div class="row align-items-center">
                                <div class="col-lg-4 col-md-12">
                                    <div class="featured-image">
                                        <a 
                                            [routerLink]="['/tutorial', content.attributes.slug]"
                                        >
                                            <img [src]="content.attributes.image.data.attributes.url" alt="image">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-12">
                                    <div class="featured-content">
                                        <ul class="featured-list">
                                            <li>Catégorie : {{content.attributes.tutorial_category?.data.attributes.title}}</li>
                                        </ul>
                                        <h3>
                                            <a
                                                [routerLink]="['/tutorial', content.attributes.slug]"
                                            >
                                                {{content.attributes.title}}
                                            </a>
                                        </h3>
                                        <p>Niveau : <em>{{content.attributes.tutorial_level}}</em></p>
                                        <ul class="featured-btn-list">
                                            <li class="time-to-read">
                                                <i class="ri-timer-line"></i> <span>{{content.attributes.tutorial_reading_time}}</span>
                                            </li>
                                            <li class="time-to-read">
                                                 <i class="ri-shield-user-line"></i> <em>{{content.attributes.author}}</em>
                                            </li>
                                            <li class="time-to-read">
                                                <i class="flaticon-writing"></i> <span>{{content.attributes.publishedAt | date:'fullDate':'fr' }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
            <div class="featured-bold-text">Tutoriels</div>
        </div>
    </div>
</div>